/**
 * Exports all versions and metadata for the Platform Privacy Notice
 * Version history documentation began in February 2025
 */

import { type Version, type VersionHistoryEntry } from "../types";
import { jan2025 } from "./jan-2025";
import { current } from "./current";

// List versions in order of newest to oldest
export const versions: Record<string, Version> = {
  current: {
    content: current,
    date: "March 11, 2025",
  },
  "jan-2025": {
    content: jan2025,
    date: "January 21, 2025",
  },
};

// Version history excludes the current version
// List in order of newest to oldest
export const versionHistory: VersionHistoryEntry[] = [
  {
    version: "jan-2025",
    date: versions["jan-2025"].date,
    path: "/platform-privacy/jan-2025",
  },
];

export const currentVersion = versions.current;
